import { render, staticRenderFns } from "./tahsilatdialog.vue?vue&type=template&id=556db546"
import script from "./tahsilatdialog.vue?vue&type=script&lang=js"
export * from "./tahsilatdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports